module.exports = __webpack_public_path__ + "img/微信图片_20211108192003.edf395fe.jpg";